import { apiCallsRequestCache } from '@/app/services/apiCallsRequestCache'

export default defineNuxtPlugin(() => {
  document.addEventListener('visibilitychange', () => {
    apiCallsRequestCache.handleVisibilityChange(document.hidden)
  })
})
